import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DisplayOptions } from '../bh-plugin-generated-form.js';

// ===== Train the Trainer Workshops und Beratungen =====

export const tttRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::ttt',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new TTTStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(TTTStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => TTTStammdaten,
};

@Entity()
export class TTTStammdaten extends UserStammdaten {
  static override _class = 'TTTStammdaten';

  override getTranslationNamespace() {
    return 'ttt';
  }

  @Field(type => String)
  @validate(nonOptional())
  organisation: Maybe<string>;

  @Field(type => String)
  @validate(nonOptional())
  occupation: Maybe<string>;

  @Field(type => String)
  @DisplayOptions({
    useTextarea: true,
  })
  consultationRequestDescription: Maybe<string>;
}
